/** 사람의 표시 이름과, 계정이 사라진 뒤의 라벨 (PRD §8.3.3). 화면의 얼굴은 이 글자를 그리지 않고 사람 아이콘을 쓴다. */

export const DELETED_USER_LABEL = "삭제된 사용자";

const HANGUL = /[가-힣]/;

/**
 * 표시 이름의 1~2자.
 * 한글은 성 한 자와 이름 첫 자. 영문은 두 단어의 머리글자, 한 단어면 두 글자.
 */
export function personInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "";
  const parts = trimmed.split(/\s+/).filter(Boolean);
  const first = [...trimmed][0] ?? "";
  if (HANGUL.test(first)) {
    const rest = [...trimmed].slice(1).find((ch) => HANGUL.test(ch) || /[A-Za-z0-9]/.test(ch));
    return rest ? first + rest : first;
  }
  if (parts.length >= 2) return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  return trimmed.slice(0, 2).toUpperCase();
}

export function personFace(name: string, deleted: boolean): { initials: string; label: string } {
  return {
    initials: personInitials(name),
    label: deleted ? DELETED_USER_LABEL : name,
  };
}
